import { format, parseISO } from "date-fns";
import { TypographyStandardTitleH2 } from "src/components/typography"
import { Iteration, Team } from "src/types"

type props = {
    projectName: string,
    TotalWorkItem: number,
    completedWorkItem: number,
    totalTeam: (Team & {
        userCapacity: number, iterations?: {
            userCapacity: number;
            iteration: Iteration;
            workItemCompleted: any[];
            workItemUnCompleted: any[];
            totalWorkItemCount: number;
        }[]
    })[],
    totalTodayCapacity: number;
    totalPendingCapacityToday: number;
}

export function ProjectComponent(props: props) {

    return (
        <div className='border p-2 rounded-md grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4'>
            <div className='w-full flex gap-2 md:col-span-3 '>
                <TypographyStandardTitleH2>{props.projectName}</TypographyStandardTitleH2>
            </div>
            <div className=' flex col-span-1 md:col-span-2'>
                <div className=' flex flex-col w-full place-items-end'>

                    <div className='flex'>
                        <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                        <p className=" pl-1">{props.TotalWorkItem}</p>
                    </div>
                    <div className='flex'>
                        <TypographyStandardTitleH2>Completed Work Item: </TypographyStandardTitleH2>
                        <p className="pl-1">{props.completedWorkItem}</p>
                    </div>
                    {
                        props.totalTeam.map((team) => {

                            return (
                                <div key={team.id} className="border p-2 rounded-md">
                                    <div className='flex'>
                                        <TypographyStandardTitleH2>Team:  </TypographyStandardTitleH2>
                                        <p className="pl-1">{team.name}</p>
                                    </div>
                                    {team.iterations?.map((iteration) => {
                                        // Parse the ISO string into a JavaScript Date object
                                        const startDate = iteration.iteration.attributes.startDate ? parseISO(iteration.iteration.attributes.startDate) : ''
                                        // Format the date to 'dd-MM-yyyy'
                                        const formattedStartDate = startDate ? format(startDate, 'dd-MM-yyyy') : '';
                                        // Parse the ISO string into a JavaScript Date object
                                        const finishDate = iteration.iteration.attributes.finishDate ? parseISO(iteration.iteration.attributes.finishDate) : ''
                                        // Format the date to 'dd-MM-yyyy'
                                        const formattedFinishDate = finishDate ? format(finishDate, 'dd-MM-yyyy') : '';
                                        
                                        //check the end date exeeded current date.
                                        const currentDate = new Date();
                                        const endDate = new Date(iteration.iteration.attributes.finishDate);
                                        endDate.setHours(23, 59, 59, 999);
                                        currentDate.setHours(0, 0, 0, 0);
                                        const isEndDateExeeded = endDate < currentDate

                                        return (
                                            <div className={`border p-2 rounded-md 
                                            ${iteration.iteration.attributes.timeFrame === 'current' && !isEndDateExeeded ? 'bg-blue-200' : `
                                                ${iteration.iteration.attributes.timeFrame==='past'|| isEndDateExeeded?
                                                iteration.workItemUnCompleted.length>0 ? 'bg-red-200' : 'bg-green-200'
                                                : ''}
                                                `}
                                            `}>
                                                <div className='flex'>
                                                    <TypographyStandardTitleH2>IterationName: </TypographyStandardTitleH2>
                                                    <p className="pl-1">{iteration.iteration.name}</p>
                                                </div>
                                                <div className='flex'>
                                                    <TypographyStandardTitleH2>Start Date:  </TypographyStandardTitleH2>
                                                    <p className="pl-1">{formattedStartDate}</p>
                                                </div>
                                                <div className='flex'>
                                                    <TypographyStandardTitleH2>End Date:  </TypographyStandardTitleH2>
                                                    <p className="pl-1">{formattedFinishDate}</p>
                                                </div>
                                                <div className='flex'>
                                                    <TypographyStandardTitleH2>Work Items status:  </TypographyStandardTitleH2>
                                                    <p className="pl-1">{iteration.workItemCompleted.length}/{iteration.totalWorkItemCount}</p>
                                                </div>
                                                
                                                <div className='flex'>
                                                    <TypographyStandardTitleH2>Capacity today: </TypographyStandardTitleH2>
                                                    <p className="pl-1">{iteration.userCapacity}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })
                    }
                    <div className='flex'>
                        <TypographyStandardTitleH2>Total today Capacity: </TypographyStandardTitleH2>
                        <p className="pl-1">{props.totalTodayCapacity}</p>
                    </div>
                    <div className='flex'>
                        <TypographyStandardTitleH2>Today pending Capacity: </TypographyStandardTitleH2>
                        <p className="pl-1">{props.totalPendingCapacityToday}</p>
                    </div>
                </div>
            </div>
        </div>
    )

}